import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { get, post as lowLevelPost } from "../../Common/api";
import config from "../../config";
import { setLoginRedirect } from "../../redux/loginRedirectSlice";

const LoginForm = () => {
  const [errorMessage, setErrorMessage] = useState();
  const [validationMessage, setValidationMessage] = useState();
  const [username, setUsername] = useState('');
  const [emailValidationMessage, setEmailValidationMessage] = useState();
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState("start");
  const { search } = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(search);
  const returnUrl = queryParams.get("returnUrl");
  const dispatch = useDispatch();

  useEffect(() => {
    // Logout Admin API
    get(`/Account/Logout`).then(() => {}).catch(e => console.error(e));
    // Logout Admin website
    fetch(`${config.adminPortalWebsiteOrigin}/Account/Logout`).then(() => {}).catch(e => console.error(e));
  }, []);

  useEffect(() => {
    if (returnUrl) {
      document.cookie = `returnUrl=${encodeURIComponent(returnUrl)}; SameSite=Strict; Secure`;
    }
  }, [returnUrl]);

  const title =
    step === "login" ? null : step === "email" ? (
      "Your organization is using a new way to sign in. " +
      "Please enter your email address so we can get started."
    ) : step === "vanco" ? (
      <React.Fragment>
        <p>
          We've sent you an email inviting you to sign up.
          Once complete, you may sign in with your new
          email and password.
        </p>
      </React.Fragment>
    ) : step === "existing-vanco" ? (
      <React.Fragment>
        <p>
        Looks like you already have an account associated with that email address.
        Please enter the email address and click Next to continue.
        </p>
      </React.Fragment>
    ) : step === "reset-email-sent" ? (
      "A reset password link has been sent to any accounts registered with your email. " +
      "Please check your email to complete the process."
    ) : step === "select-client" ? (
      "There is more than one organization associated with this user account. Please select an organization to continue."
    ) :null;

  const clearAllMessages = () => {
    setErrorMessage();
    setValidationMessage();
    setEmailValidationMessage();
  };

  const handleSubmitInitialForm = event => {
    event.preventDefault();
    submitInitialForm();
  };

  const submitInitialForm = async () => {
    clearAllMessages();
    if (!username) {
        setEmailValidationMessage("Email is required");
    } else {
        // Login through IDS page since this user is managed by an external SSO provider
        const idsLoginUrl = `${config.adminApiOrigin}/Account/IdentityServiceLogin?username=${encodeURIComponent(username)}`;
        dispatch(setLoginRedirect({
          url: idsLoginUrl,
          message: "Redirecting you to your Single Sign-on Provider"
        }));
        history.push(`${config.loginRoot}/redirect`);
    }
  };
  
  const errorMessageClass =
    "alert alert-danger " +
    (errorMessage ? "display-show" : "display-hide");

  let emailClass = "form-group";
  if (emailValidationMessage) {
    emailClass += " has-error";
  }

  const initialForm = (
    <React.Fragment>
      <form name="login" key="login" onSubmit={handleSubmitInitialForm}>
        <div className={emailClass}>
          {/*ie8, ie9 does not support html5 placeholder, so we just show field title for that*/}
          <label className="control-label visible-ie8 visible-ie9">
            Email
          </label>
          <div className="input-icon">
            <i className="fa fa-user" />
            <input
              id="username"
              className="form-control placeholder-no-fix"
              type="text"
              placeholder="Email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              name="username"
            />
          </div>
          {emailValidationMessage ? (
            <span htmlFor="username" className="help-block">
              {emailValidationMessage}
            </span>
          ) : null}
        </div>
        <div className="form-actions">
          <button
            type="button"
            disabled={loading}
            className="btn green pull-right"
            aria-label="next"
            onClick={() => submitInitialForm()}
          >
            Next
            { loading
              ? <i className="fa fa-spinner fa-spin" />
              : <i className="m-icon-swapright m-icon-white" />
            }
          </button>
        </div>{" "}
      </form>
    </React.Fragment>
  ) 
  
  const form =
    step === "start" || step === "reset-email-sent" || step === "vanco" || step === "existing-vanco"
      ? initialForm
      : step === "login";
  const validationSummaryClass = validationMessage
    ? "validation-summary-errors"
    : "validation-summary-valid";


  return (
    <React.Fragment>
      <h4 className="form-title">{title}</h4>
      <div className={errorMessageClass}>
        <button className="close" onClick={() => setErrorMessage()} />
        <span>{errorMessage}</span>
      </div>
      <div className={validationSummaryClass}>
        <ul>{validationMessage ? <li>{validationMessage}</li> : null}</ul>
      </div>{" "}
      {form}
    </React.Fragment>
  );
};

export default LoginForm;
